import * as api from '@/api'
import * as http from '@/libs/http'

const REASON_REGISTERED = [
  '会員として登録を完了しています。',
  '会員情報の変更をする時は、ユーザーメニューから変更頂けます。'
]

const REASON_INVALID = [
  '会員登録には情報が不足しています。'
]

const REASON_DUPLICATED = [
  'このログインアカウントは既に登録されています。'
]

export default {
  /**
   * 新規に会員登録する
   *
   * @param {Content} context
   */
  async register ({ state, getters, commit, rootGetters }) {
    // 既に登録済みか
    if (getters.isRegistered) {
      return {
        ok: false,
        reason: REASON_REGISTERED
      }
    }

    // 必要事項が入力されたか
    if (!getters.valid) {
      return {
        ok: false,
        reason: REASON_INVALID
      }
    }

    // 組織コードを取得する
    const orgcode = rootGetters['org/code']

    // ユーザ情報をまとめる
    const user = {
      account: state.account,
      profile: state.profile,
      license: state.license,
      optins: state.optins
    }

    // 会員登録する
    const resp = await api.newUser(orgcode, user)
    if (resp.status === http.Conflict) {
      // 既に登録がある
      return {
        ok: false,
        reason: REASON_DUPLICATED
      }
    } else if (resp.status !== http.Created) {
      // 不明なエラー
      return {
        ok: false,
        reason: [`不明なエラーが発生しました。 code = ${resp.status} ${resp.statusText}`]
      }
    }

    // 登録結果を保存する
    commit('setResult', resp.data)

    // ログインの状態にする
    commit('user/setData', resp.data, { root: true })

    // 正常終了
    return { ok: true }
  },

  /**
   * 会員登録を完了する
   *
   * @param {Content} context
   */
  close ({ state, commit }) {
    // 会員登録情報をクリアする
    commit('clear')
  }
}
